import { BlurFade } from '@/components/ui/blur-fade';
import { Settings, ArrowRightLeft, BarChart3 } from 'lucide-react';

const steps = [
  {
    number: '01',
    icon: Settings,
    title: 'Configure Your Organization',
    description:
      'Set up your teams, categories, SLA policies, and automation rules. Customize your customer portal with your own branding.',
  },
  {
    number: '02',
    icon: ArrowRightLeft,
    title: 'Receive & Route Tickets',
    description:
      'Customers submit tickets via portal, email, or API. Automation rules instantly categorize, prioritize, and assign them to the right agents.',
  },
  {
    number: '03',
    icon: BarChart3,
    title: 'Resolve & Measure',
    description:
      'Agents collaborate in real-time to resolve issues. Track SLA compliance, first response time, and team performance with built-in analytics.',
  },
];

export function HowItWorksSection() {
  return (
    <section id="how-it-works" className="py-16 sm:py-24 px-4 sm:px-6 lg:px-8 bg-muted/50">
      <div className="mx-auto max-w-6xl">
        <BlurFade inView>
          <div className="text-center mb-10 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-foreground">
              How It Works
            </h2>
            <p className="mt-3 sm:mt-4 text-sm sm:text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
              Get up and running in three simple steps.
            </p>
          </div>
        </BlurFade>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-4 relative">
          {/* Connecting line (desktop only) */}
          <div className="hidden md:block absolute top-24 left-[20%] right-[20%] h-[2px] border-t-2 border-dashed border-border" />

          {steps.map((step, index) => (
            <BlurFade key={step.number} delay={index * 0.15} inView>
              <div className="relative text-center px-4">
                <div className="text-5xl md:text-6xl font-bold text-primary/10 mb-2">
                  {step.number}
                </div>
                <div className="mx-auto mb-4 inline-flex h-14 w-14 items-center justify-center rounded-full bg-primary text-primary-foreground shadow-lg">
                  <step.icon className="h-7 w-7" />
                </div>
                <h3 className="text-xl font-semibold text-foreground mb-2">
                  {step.title}
                </h3>
                <p className="text-muted-foreground leading-relaxed">
                  {step.description}
                </p>
              </div>
            </BlurFade>
          ))}
        </div>
      </div>
    </section>
  );
}
